import api from './api'

const localStorage = window.localStorage

export interface Auth {
  login(email: string, pass: string, cb?: (ok: boolean) => void): void
  resetPassword(email: string, cb: (err: Error | null, body?: unknown) => void): void
  refresh(cb?: (ok: boolean) => void): void
  getToken(): string | undefined
  setToken(token: string): void
  clearToken(): void
  logout(cb?: (ok: boolean) => void): void
  loggedIn(): boolean
  onChange(loggedIn: boolean): void
}

const auth: Auth = {
  login (email, pass, cb) {
    cb = arguments[arguments.length - 1]
    if (localStorage.token) {
      if (cb) cb(true)
      this.onChange(true)
      return
    }

    const requestOptions = {
      body: {
        email,
        password: pass
      }
    }

    api.post('auth/login', requestOptions)
      .then((res) => (res as Response).json())
      .then((obj: { token?: string }) => {
        if (obj.token) {
          this.setToken(obj.token)
          if (cb) cb(true)
          this.onChange(true)
        } else {
          if (cb) cb(false)
          this.onChange(false)
        }
      })
  },

  resetPassword (email, cb) {
    const requestOptions = {
      body: {
        email,
        source: 'ncfdd-admin'
      }
    }

    api.post('v2/users/password/new', requestOptions)
      .then((res) => (res as Response).json())
      .then((body: unknown) => cb(null, body))
      .catch((e: Error) => cb(e))
  },

  refresh (cb) {
    api.post('auth/refresh')
      .then((res) => (res as Response).json())
      .then((obj: { token?: string }) => {
        if (obj.token) {
          this.setToken(obj.token)
          if (cb) cb(true)
          this.onChange(true)
        } else {
          if (cb) cb(false)
          this.onChange(false)
        }
      })
  },

  getToken () {
    return localStorage.token
  },

  setToken (token) {
    localStorage.token = token
  },

  clearToken () {
    localStorage.removeItem('token')
  },

  logout (cb) {
    api.post('auth/logout')
      .then(
        () => {
          delete localStorage.token
          if (cb) cb(true)
        },
        () => {
          if (cb) cb(false)
          this.onChange(false)
        }
      )
  },

  loggedIn () {
    return !!localStorage.token
  },

  onChange (_loggedIn: boolean) {}
}

export default auth
